/**
 * Limits on a vendor's profile (docs/vendor-growth.spec.md).
 *
 * Nothing a vendor does costs it anything, and uploads are not otherwise
 * metered. Two of these are the free limits a paid tier would raise later, the
 * gallery and the video and audio links, so they are set with room for that
 * (decided 2026-10-23). The rest are sanity caps; packages, certificates and
 * reviews are never limited for money.
 */

/** What the business is, in its own words. */
export const VENDOR_DESCRIPTION_MAX = 1500

/**
 * Photos in a vendor's gallery: the free limit, and one a paid tier would raise
 * (docs/vendor-growth.spec.md, "Room for a paid tier later").
 */
export const MAX_VENDOR_PHOTOS = 12

/** A photo's caption: its alt text, so a description, not a paragraph. */
export const MAX_VENDOR_PHOTO_CAPTION = 200

/** Video and audio links on a profile: the free limit, and the other a paid tier would raise. */
export const MAX_VENDOR_MEDIA_LINKS = 3

/** Packages and items, across all of a vendor's services. */
export const MAX_VENDOR_OFFERINGS = 60

/** Photos on one package or item. */
export const MAX_OFFERING_PHOTOS = 6

export const OFFERING_NAME_MAX = 120

export const OFFERING_DESCRIPTION_MAX = 1000

/** Entries in one of an offering's lists: courses, deliverables, equipment. */
export const OFFERING_LIST_ITEMS_MAX = 12

/** Characters in one of those entries. */
export const OFFERING_LIST_ITEM_MAX = 120

/** One million dollars, in cents: past any wedding vendor's price, short of a typo's. */
export const PRICE_CENTS_MAX = 100_000_000

/** A website or social address. */
export const PROFILE_URL_MAX = 300

/** How many photos of its work the profile checklist asks a company for. */
export const CHECKLIST_PHOTOS = 3
